import { render, staticRenderFns } from "./ProblemDetail.vue?vue&type=template&id=53eed042&scoped=true&"
import script from "./ProblemDetail.vue?vue&type=script&lang=js&"
export * from "./ProblemDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProblemDetail.vue?vue&type=style&index=0&id=53eed042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eed042",
  null
  
)

export default component.exports